import {ApiService} from "./api.service";

export class LandingPageService extends ApiService {
  constructor(organizationId) {
    super();
    this.endpoint = `/organizations/${organizationId}/landing_page`;
  }

  async loadData(params) {
    let url = `${this.endpoint}/landing_page_data`;
    return await this.get(url, params);
  }

  async show(id) {
    return super.show(id);
  }

  async index(params){
    return super.index(params);
  }

  async create(params){
    return super.create(params);
  }
  async update(id, params){
    return super.update(id, params);
  }

  async archiveComponent(orgId, componentId) {
    const url = `/organizations/${orgId}/website/components/${componentId}/archive`;
    return await super.patch(url);
  }

  async reorderLandingPage(orgId, pageId, params) {
    let url = `/organizations/${orgId}/website/pages/${pageId}/reorder`;
    return await super.patch(url, params);
  }

}
